import React from "react";
import { Drawer } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DRAWER_TYPES } from "Constantes/drawers";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { Notifications } from "../Notifications/Notifications";
import "./NotificationsDrawer.scss";

/**
 * Componente de cajón lateral que contiene las notificaciones de la aplicación.
 * Utiliza Material-UI Drawer y se controla mediante Redux para mostrar/ocultar.
 * @returns {JSX.Element} Componente NotificationsDrawer renderizado
 */
export const NotificationsDrawer = () => {
  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const open = activeDrawer === DRAWER_TYPES.NOTIFICATIONS;

  const onClose = () => {
    dispatch(setActiveDrawer(null));
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      hideBackdrop
      className="notifications-drawer"
    >
      <Notifications onClose={onClose} />
    </Drawer>
  );
};
